import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import LocationManagement from 'components/Admin/LocationManagement';
// eslint-disable-next-line
export default function ZoneManagementScreen() {
  return (
    <ContentLayout>
      <SiteContent>
        <LocationManagement />
      </SiteContent>
    </ContentLayout>
  );
}
